(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7668],{

/***/ 91990:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/locations/[[...slug]]",
      function () {
        return __webpack_require__(1903);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 87762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ FastAndReliableSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3210);



var FastAndReliableSection = function(param) {
    var title = param.title;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "text-center pt-0",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Container__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "title",
                    children: title || "FAST AND RELIABLE BRAKE REPAIR"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                    className: "description text-xl",
                    children: [
                        "Experience fast and reliable brake repair you can trust, confidently backed by over",
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                            children: "15,000 five-star Google Reviews"
                        }),
                        " from satisfied customers. At Nubrakes, we understand that your brakes are your car's most important safety feature. That's why we take care of them like they're our own. Our skilled technicians use only high-quality parts and equipment to ensure you get the best brake repair possible."
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 1903:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@builder.io/react/dist/builder-react.es5.js
var builder_react_es5 = __webpack_require__(18202);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/LoadingIndicator.tsx
var LoadingIndicator = __webpack_require__(73803);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Builder/CodeComponentsRegistration.tsx + 34 modules
var CodeComponentsRegistration = __webpack_require__(32758);
// EXTERNAL MODULE: ./src/components/Layout.tsx + 1 modules
var Layout = __webpack_require__(22932);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./src/components/utils/string-utils.ts
var string_utils = __webpack_require__(2638);
// EXTERNAL MODULE: ./src/components/LandingPageButton.tsx
var LandingPageButton = __webpack_require__(17743);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-duotone-svg-icons/index.mjs
var pro_duotone_svg_icons = __webpack_require__(21702);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-duotone-svg-icons/faCalendarCheck.js
var faCalendarCheck = __webpack_require__(52375);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-duotone-svg-icons/faCarMechanic.js
var faCarMechanic = __webpack_require__(67170);
// EXTERNAL MODULE: ./src/components/Container.tsx
var Container = __webpack_require__(3210);
;// CONCATENATED MODULE: ./src/components/Builder/components/ServicesHowItWorks.tsx











var ServicesHowItWorksSection = function(param) {
    var title = param.title, description = param.description, steps = param.steps, buttonText = param.buttonText, phoneNumber = param.phoneNumber;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "px-2 md:px-8",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col justify-center justify-items-center content-center items-center self-center place-items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "title",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "description",
                        children: description
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "grid md:grid-cols-3",
                    style: {
                        background: "white",
                        boxShadow: "0 13px 27px -5px rgba(50, 50, 93, .25), 0 8px 16px -8px rgba(0, 0, 0, .3), 0 -6px 16px -6px rgba(0, 0, 0, .025)"
                    },
                    children: steps && steps.map(function(v) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, v), {
                            stepImage: v.image
                        });
                    }).map(function(value, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(HowItWorksStep, (0,_object_spread/* default */.Z)({}, value), index);
                    })
                })
            }),
            buttonText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pt-5 flex flex-col justify-center justify-items-center content-center items-center self-center place-items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingPageButton/* LandingPageButton */.K, {
                    buttonText: buttonText
                })
            }),
            phoneNumber && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-2",
                children: [
                    "Or call us at ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "tel:".concat(phoneNumber),
                        children: (0,string_utils/* formatPhoneNumber */.u)(phoneNumber)
                    })
                ]
            })
        ]
    });
};
var HowItWorksStep = function(param) {
    var title = param.title, description = param.description, stepImage = param.stepImage;
    console.log("stepImage", stepImage, stepImage === "faCarMechanic");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "py-4 flex flex-grow-1 flex-col h-100 text-center px-6",
        style: {
            border: "1px solid #dddddd"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mx-auto",
                children: [
                    stepImage === "faMoneyCheckEditAlt" && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        size: "4x",
                        color: "#ea3616",
                        icon: pro_duotone_svg_icons/* faMoneyCheckEditAlt */.v4z
                    }),
                    stepImage === "faCalendarCheck" && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        size: "4x",
                        color: "#ea3616",
                        icon: faCalendarCheck/* faCalendarCheck */.Ry
                    }),
                    stepImage === "faCarMechanic" && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        size: "4x",
                        color: "#ea3616",
                        icon: faCarMechanic/* faCarMechanic */.cC
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "description",
                        children: description
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/Builder/components/CarBrandGrid.tsx
var CarBrandGrid = __webpack_require__(65105);
// EXTERNAL MODULE: ./src/components/CityPage/FastAndReliableSection.tsx
var FastAndReliableSection = __webpack_require__(87762);
// EXTERNAL MODULE: ./src/components/CarPage/FAQSection.tsx
var FAQSection = __webpack_require__(6550);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/components/LandingPage/BrakeRepairNearYouWithCities.tsx
var BrakeRepairNearYouWithCities = __webpack_require__(61042);
;// CONCATENATED MODULE: ./node_modules/lucide-react/dist/esm/shared/src/utils.js
/**
 * @license lucide-react v0.541.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const toKebabCase = (string) => string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const toCamelCase = (string) => string.replace(
  /^([A-Z])|[\s-_]+(\w)/g,
  (match, p1, p2) => p2 ? p2.toUpperCase() : p1.toLowerCase()
);
const toPascalCase = (string) => {
  const camelCase = toCamelCase(string);
  return camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
};
const mergeClasses = (...classes) => classes.filter((className, index, array) => {
  return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index;
}).join(" ").trim();
const hasA11yProp = (props) => {
  for (const prop in props) {
    if (prop.startsWith("aria-") || prop === "role" || prop === "title") {
      return true;
    }
  }
};


//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ./node_modules/lucide-react/dist/esm/defaultAttributes.js
/**
 * @license lucide-react v0.541.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

var defaultAttributes = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};


//# sourceMappingURL=defaultAttributes.js.map

;// CONCATENATED MODULE: ./node_modules/lucide-react/dist/esm/Icon.js
/**
 * @license lucide-react v0.541.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */





const Icon = (0,react.forwardRef)(
  ({
    color = "currentColor",
    size = 24,
    strokeWidth = 2,
    absoluteStrokeWidth,
    className = "",
    children,
    iconNode,
    ...rest
  }, ref) => (0,react.createElement)(
    "svg",
    {
      ref,
      ...defaultAttributes,
      width: size,
      height: size,
      stroke: color,
      strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
      className: mergeClasses("lucide", className),
      ...!children && !hasA11yProp(rest) && { "aria-hidden": "true" },
      ...rest
    },
    [
      ...iconNode.map(([tag, attrs]) => (0,react.createElement)(tag, attrs)),
      ...Array.isArray(children) ? children : [children]
    ]
  )
);


//# sourceMappingURL=Icon.js.map

;// CONCATENATED MODULE: ./node_modules/lucide-react/dist/esm/createLucideIcon.js
/**
 * @license lucide-react v0.541.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */





const createLucideIcon = (iconName, iconNode) => {
  const Component = (0,react.forwardRef)(
    ({ className, ...props }, ref) => (0,react.createElement)(Icon, {
      ref,
      iconNode,
      className: mergeClasses(
        `lucide-${toKebabCase(toPascalCase(iconName))}`,
        `lucide-${iconName}`,
        className
      ),
      ...props
    })
  );
  Component.displayName = toPascalCase(iconName);
  return Component;
};


//# sourceMappingURL=createLucideIcon.js.map

;// CONCATENATED MODULE: ./node_modules/lucide-react/dist/esm/icons/phone.js
/**
 * @license lucide-react v0.541.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [
  [
    "path",
    {
      d: "M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384",
      key: "9njp5v"
    }
  ]
];
const Phone = createLucideIcon("phone", __iconNode);


//# sourceMappingURL=phone.js.map

;// CONCATENATED MODULE: ./node_modules/lucide-react/dist/esm/icons/map-pin.js
/**
 * @license lucide-react v0.541.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const map_pin_iconNode = [
  [
    "path",
    {
      d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
      key: "1r0f0z"
    }
  ],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }]
];
const MapPin = createLucideIcon("map-pin", map_pin_iconNode);


//# sourceMappingURL=map-pin.js.map

;// CONCATENATED MODULE: ./node_modules/lucide-react/dist/esm/icons/clock.js
/**
 * @license lucide-react v0.541.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const clock_iconNode = [
  ["path", { d: "M12 6v6l4 2", key: "mmk7yg" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
];
const Clock = createLucideIcon("clock", clock_iconNode);


//# sourceMappingURL=clock.js.map

;// CONCATENATED MODULE: ./node_modules/lucide-react/dist/esm/icons/check.js
/**
 * @license lucide-react v0.541.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const check_iconNode = [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]];
const Check = createLucideIcon("check", check_iconNode);


//# sourceMappingURL=check.js.map

;// CONCATENATED MODULE: ./src/components/LocationPage/ConsultationLocationSection.tsx



var ConsultationLocationSection = function(param) {
    var location = param.location;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "!bg-slate-200 w-full py-12",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container mx-auto px-4",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-w-4xl mx-auto",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        className: "text-3xl text-center mb-6 text-base sm:text-3xl",
                        children: [
                            "ON-SITE CONSULTATION IN ",
                            location.city.toUpperCase()
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid grid-cols-2 gap-4 mb-8 max-w-md mx-auto",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                href: "tel:".concat(location.phone.replace(/[^0-9]/g, "")),
                                className: "bg-primary text-white font-bold py-3 px-4 rounded-md text-center flex items-center justify-center transition-all hover:bg-primary/90 text-xs whitespace-nowrap",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Phone, {
                                        className: "w-5 h-5 mr-2"
                                    }),
                                    "CALL US"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                href: "https://www.google.com/maps/search/?api=".concat("AIzaSyBWC6myML7m_2VvLL9NYl6S3NhgnsvCYDk", "&query=").concat(encodeURIComponent("".concat(location.address, ", ").concat(location.city, ", ").concat(location.state, " ").concat(location.zip))),
                                target: "_blank",
                                rel: "noopener noreferrer",
                                className: "bg-green-500 text-white font-bold py-3 px-4 rounded-md text-center flex items-center justify-center transition-all hover:bg-green-500/90 text-xs whitespace-nowrap",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MapPin, {
                                        className: "w-5 h-5 mr-2"
                                    }),
                                    "GET DIRECTIONS"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col lg:flex-row gap-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full lg:w-1/2 order-1 lg:order-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "bg-white rounded-lg shadow-lg h-full overflow-hidden",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                        src: "https://www.google.com/maps?q=".concat(encodeURIComponent("".concat(location.address, ", ").concat(location.city, ", ").concat(location.state, " ").concat(location.zip)), "&output=embed"),
                                        width: "100%",
                                        height: "100%",
                                        className: "border-0 min-h-[300px] lg:min-h-[450px]",
                                        allowFullScreen: true,
                                        loading: "lazy",
                                        referrerPolicy: "no-referrer-when-downgrade",
                                        title: "Map of ".concat(location.city, " Location")
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full lg:w-1/2 order-2 lg:order-1 mt-6 lg:mt-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "rounded-lg overflow-hidden shadow-lg h-full",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "bg-[#03182A] text-white p-4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex items-start",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MapPin, {
                                                        className: "text-primary mt-1 mr-2 flex-shrink-0"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                                                className: "text-lg",
                                                                children: [
                                                                    location.city,
                                                                    " Location"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                className: "text-sm",
                                                                children: [
                                                                    location.address,
                                                                    ", ",
                                                                    location.city,
                                                                    ", ",
                                                                    location.state,
                                                                    " ",
                                                                    location.zip
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "bg-white p-4",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "mb-4",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "flex items-center mb-2",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "w-8 h-8 rounded-full bg-navy/10 flex items-center justify-center mr-2",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Phone, {
                                                                        className: "w-4 h-4 text-navy"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                    className: "text-gray-800",
                                                                    children: "Contact"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "tel:".concat(location.phone.replace(/[^0-9]/g, "")),
                                                            className: "text-primary font-medium block ml-10",
                                                            children: location.phone
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "mb-4",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "flex items-center mb-2",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "w-8 h-8 rounded-full bg-navy/10 flex items-center justify-center mr-2",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Clock, {
                                                                        className: "w-4 h-4 text-navy"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                    className: "text-gray-800",
                                                                    children: "Hours"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "ml-10 space-y-2",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "flex justify-between",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: "text-xs font-bold uppercase text-gray-500",
                                                                            children: "WEEKDAYS"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: "text-sm",
                                                                            children: location.hours.weekday
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "flex justify-between",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: "text-xs font-bold uppercase text-gray-500",
                                                                            children: "SATURDAY"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: "text-sm",
                                                                            children: location.hours.saturday
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "flex justify-between",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: "text-xs font-bold uppercase text-gray-500",
                                                                            children: "SUNDAY"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: "text-sm",
                                                                            children: location.hours.sunday
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "mb-4",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "flex items-center mb-2",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "w-8 h-8 rounded-full bg-navy/10 flex items-center justify-center mr-2",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MapPin, {
                                                                        className: "w-4 h-4 text-navy"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                    className: "text-gray-800",
                                                                    children: "Services at this location"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                            className: "ml-10 space-y-2",
                                                            children: location.services.map(function(service, index) {
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                    className: "flex items-start",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "mt-0.5 mr-2 text-navy flex-shrink-0",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Check, {
                                                                                className: "w-4 h-4"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "text-sm",
                                                                            children: service
                                                                        })
                                                                    ]
                                                                }, index);
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "border-t border-gray-200 p-3 bg-white",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "text-xs text-center text-gray-700",
                                                children: [
                                                    "All brake repairs are completed by NuBrakes mobile technicians at your home or office, or by appointment at ",
                                                    location.address,
                                                    ", ",
                                                    location.city,
                                                    ", ",
                                                    location.state,
                                                    " ",
                                                    location.zip,
                                                    "."
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/Forms/ScheduleServiceMultiStep/NoEmailScheduleServiceFormMultiStep.tsx + 2 modules
var NoEmailScheduleServiceFormMultiStep = __webpack_require__(42786);
// EXTERNAL MODULE: ./src/components/SEMPage/StarsAndRatings.tsx
var StarsAndRatings = __webpack_require__(39925);
// EXTERNAL MODULE: ./src/hooks/useQueryParam.tsx
var useQueryParam = __webpack_require__(73401);
// EXTERNAL MODULE: ./public/img/nubrakes-van-house-800-num.jpg
var nubrakes_van_house_800_num = __webpack_require__(5426);
;// CONCATENATED MODULE: ./src/components/LandingPage/HomeScheduleServiceHeaderForm.tsx











var HomeScheduleServiceFormHeader = function(param) {
    var title = param.title, rating = param.rating, reviewCount = param.reviewCount, subheading = param.subheading;
    var query = (0,useQueryParam/* useQueryParam */.W)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    zIndex: -100,
                    top: 0,
                    left: 0
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "py-8 flex flex-col justify-center align-center w-full h-full min-h-[60vh] relative",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: nubrakes_van_house_800_num/* default */.Z,
                            layout: "fill",
                            objectFit: "cover",
                            objectPosition: "bottom center",
                            priority: true,
                            alt: "NuBrakes Mobile Repair"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                backgroundColor: "rgba(0,0,0,.75)",
                                position: "absolute",
                                width: "100%",
                                height: "100%",
                                zIndex: 1,
                                top: 0,
                                left: 0
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
                className: "text-center z-10",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "grid lg:grid-cols-2 gap-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "text-center lg:text-left flex flex-col justify-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: "text-2xl sm:text-2xl md:text-4xl text-white sm:mb-0",
                                    children: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    style: {
                                        fontSize: 18,
                                        marginBottom: 10
                                    },
                                    className: "subheading text-white hidden sm:hidden md:block",
                                    children: subheading
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "w-auto lg:inline-block hidden mr-auto p-3 text-center",
                                    style: {
                                        backgroundColor: "rgba(0, 0, 0, 0.69)",
                                        borderRadius: 6
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StarsAndRatings/* StarsAndRatings */.G, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            style: {
                                                color: "#cbd0d3",
                                                lineHeight: 1
                                            },
                                            children: [
                                                "NuBrakes is rated ".concat(rating, "/5 by "),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: {
                                                        pathname: "/reviews/",
                                                        query: query
                                                    },
                                                    prefetch: false,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        style: {
                                                            color: "#cbd0d3",
                                                            textDecoration: "underline"
                                                        },
                                                        children: "".concat(reviewCount, " brake repair customers")
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mt-0 md:mt-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        backgroundColor: "white"
                                    },
                                    className: "flex flex-col p-6 lg:mt-0 text-left",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NoEmailScheduleServiceFormMultiStep/* NoEmailScheduleServiceFormMultiStep */.D1, {
                                        initialValues: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, NoEmailScheduleServiceFormMultiStep/* twDefaultInitialWizardFormValues */.oA), {
                                            "form-name": "getQuoteScheduleService"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-5 block lg:hidden text-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        style: {
                                            backgroundColor: "rgba(0, 0, 0, 0.69)",
                                            borderRadius: 6
                                        },
                                        className: "block px-3 py-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StarsAndRatings/* StarsAndRatings */.G, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                style: {
                                                    color: "#cbd0d3",
                                                    lineHeight: 1
                                                },
                                                children: [
                                                    "NuBrakes is rated ".concat(rating, "/5 by "),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: {
                                                            pathname: "/reviews/",
                                                            query: query
                                                        },
                                                        prefetch: false,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            style: {
                                                                color: "#cbd0d3",
                                                                textDecoration: "underline"
                                                            },
                                                            children: "".concat(reviewCount, " brake repair customers")
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/LocationPage/WhyNuBrakes.tsx



var WhyNuBrakes = function() {
    var benefits = [
        {
            title: "WE COME TO YOU",
            description: "Don't waste hours sitting at a shop. We deliver ultra-convenient repairs right where you're parked at your home or office."
        },
        {
            title: "EXPERIENCED MECHANICS",
            description: "We don't work with third-party mechanics. Our mechanics are full-time NuBrakes employees with decades of experience working on vehicles."
        },
        {
            title: "SAME-DAY AVAILABILITY",
            description: "Need your brakes repaired today? Same-day service is typically available — contact us to schedule!"
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "w-full bg-white py-8",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container mx-auto px-4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "text-3xl text-center mb-8",
                    children: "WHY NUBRAKES?"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "grid grid-cols-1 md:grid-cols-3 gap-6",
                    children: benefits.map(function(benefit, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col items-center md:items-start",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center mb-3",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "w-8 h-8 rounded-full bg-green-300 flex items-center justify-center mr-2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Check, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "text-lg",
                                            children: benefit.title
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-gray-700 text-center md:text-left",
                                    children: benefit.description
                                })
                            ]
                        }, index);
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./src/components/LocationPage/useGblLocationsByState.ts + 1 modules
var useGblLocationsByState = __webpack_require__(5477);
;// CONCATENATED MODULE: ./src/components/LocationPage/ConsultationLocationsSection.tsx





var ConsultationLocations = function() {
    var stateLocationMap = (0,useGblLocationsByState/* useGblLocationsByState */.B)("ConsultationLocations");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "!bg-slate-200 w-full py-16",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container mx-auto px-4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "text-3xl text-center mb-4",
                    children: "CONSULTATION LOCATIONS"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-center text-gray-700 mb-12 max-w-3xl mx-auto",
                    children: "We can provide service at your location, or visit us inside Valvoline for a consultation"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8",
                    children: Object.entries(stateLocationMap).map(function(param) {
                        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), state = _param[0], cities = _param[1];
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                            className: "bg-white p-6 rounded-lg shadow-sm",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "text-xl mb-4 text-navy",
                                    children: state
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "space-y-2",
                                    children: cities.map(function(city) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/locations/".concat(city.slug.replace(/^\/+/, "")),
                                                className: "text-primary hover:text-primary/80 hover:underline transition-colors",
                                                children: "".concat(city.name, " Store #").concat(city === null || city === void 0 ? void 0 : city.storeID)
                                            })
                                        }, "".concat(city.name, "-").concat(city.storeID));
                                    })
                                })
                            ]
                        }, state);
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/pages/locations/[[...slug]].tsx




















var CityNearYouSection = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8809).then(__webpack_require__.bind(__webpack_require__, 78809)).then(function(mod) {
        return mod.CityNearYouSection;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(78809)
            ];
        }
    }
});
builder_react_es5/* builder.init */.fl.init("ed7f20b509364fd4a7e520373ff39fd7");
var DynamicLocationPage = function(props) {
    var router = (0,next_router.useRouter)();
    var isRoot = props === null || props === void 0 ? void 0 : props.isRoot;
    var location = props.location;
    // const { builderCities, cities, butterCities, rating, reviewCount } = props
    var cities = props.cities;
    // const isBuilder = !!(builderCities || Builder.isEditing || Builder.isPreviewing);
    // const notBulder = !!props.city;
    var cityName = location === null || location === void 0 ? void 0 : location.name;
    var listOfZips = [];
    var listOfMinorCities = [];
    var pageTitle = !!location ? " in ".concat(cityName, ", ").concat(location === null || location === void 0 ? void 0 : location.state) : "";
    if (router.isFallback) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingIndicator/* LoadingIndicator */.T, {});
    }
    /* if (false) {
    return <NotFoundPage />
  }*/ // Makes it so only the published city pages can be viewed here
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        showGetQuote: !isRoot,
        title: "#1 Brake Repair ".concat(pageTitle, " - NuBrakes Mobile Brake Repair"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "description",
                    content: "Let our technicians take care of your concerns - at your home, work, or on-site, at a Valvoline Instant Oil Change by appointment only"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeScheduleServiceFormHeader, {
                title: "DITCH THE REPAIR SHOP — OR VISIT US FOR A QUICK CONSULTATION",
                rating: "4.95",
                reviewCount: 14270,
                subheading: ""
            }),
            !isRoot && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "my-8 flex flex-col items-center text-center px-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "text-base sm:text-3xl mb-6 max-w-4xl",
                            children: "NuBrakes — Visit Us Inside Valvoline For a Consultation or Schedule Online"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full max-w-4xl aspect-video",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                className: "w-full h-full border-0",
                                src: "https://www.youtube.com/embed/qot_8qfLxTQ?rel=0",
                                allowFullScreen: true,
                                allow: "accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            })
                        })
                    ]
                })
            }),
            isRoot && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WhyNuBrakes, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsultationLocations, {})
                ]
            }),
            location && /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsultationLocationSection, {
                location: location
            }),
            !isRoot && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "my-8 flex justify-center justify-items-center content-center items-center self-center place-items-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ServicesHowItWorksSection, {
                            title: "SKIP THE ".concat(cityName, " TRAFFIC, -  OR VISIT US FOR A QUICK CONSULTATION."),
                            description: "Let our technicians take care of your concerns - at your home, work, or on-site, at a Valvoline Instant Oil Change by appointment only",
                            buttonText: "Get a Quote Now",
                            steps: [
                                {
                                    title: "GET YOUR FREE REPAIR QUOTE",
                                    description: "Tell us what's going on with your brakes and we’ll send a free, no-obligation quote within a few minutes",
                                    image: "faMoneyCheckEditAlt"
                                },
                                {
                                    title: "SELECT YOUR REPAIR DATE",
                                    description: "Select a service that works for you (1) Mobile Brake Repair: Full service at your home or office (2) On-Site inspection at Valvoline Instant Oil Change (by appointment only).",
                                    image: "faCalendarCheck"
                                },
                                {
                                    title: "ENJOY SAFER, BETTER DRIVING",
                                    description: "Our brake technicians will ensure you're safe, confident, and back on the road — without the hassle of the shop.",
                                    image: "faCarMechanic"
                                }, 
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-center w-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mt-3",
                                children: [
                                    "Or call us at ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "tel:".concat(location.phone),
                                        children: (0,string_utils/* formatPhoneNumber */.u)(location.phone)
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "border-b-[1px] border-gray-100 pt-12"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CarBrandGrid/* CarBrandGrid */.Q, {
                        title: "We Offer Auto Repair Services On Nearly Every Model in ".concat(cityName),
                        carContent: [],
                        className: "pt-16",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-6"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FastAndReliableSection/* FastAndReliableSection */.s, {
                        title: "FAST AND RELIABLE BRAKE REPAIR IN ".concat(cityName)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQSection/* FAQSection */.v, {
                        title: "Frequently Asked Questions - ".concat(cityName, " Repair Questions"),
                        description: "Learn how NuBrakes offers convenient, expert brake service with flexible options for both on-site inspections and mobile repairs.",
                        faqs: [
                            {
                                question: "Can I Visit You In Person?",
                                answer: "Yes! You can stop by our NuBrakes service desk located inside a Valvoline Instant Oil Change to speak with a NuBrakes trained representative about a brake inspection or service consultation. All repairs are by appointment only, either at a Valvoline Instant Oil Change location or at your home or office. "
                            },
                            {
                                question: "Where Does the Actual Repair Happen?",
                                answer: "All brake repairs are performed by our mobile technicians at your home, office, or by appointment at Valvoline Instant Oil Change. Once your inspection is complete or your quote is approved, we’ll come to you with everything needed to complete the job."
                            },
                            {
                                question: "What Makes NuBrakes Different From a Typical Brake Shop?",
                                answer: "NuBrakes offers a flexible, modern alternative to the traditional shop experience. You can either visit us inside Valvoline for a consultation, or book mobile repair service and have the work done wherever you are. We combine expert service, convenience, and transparent pricing without the hassle of the shop."
                            },
                            {
                                question: "How Do I Get a Quote?",
                                answer: "Just tell us about your vehicle and the symptoms you're noticing. We’ll send you a free, no-obligation quote in under an hour, and you can choose whether to schedule a mobile repair or stop by for a consultation first."
                            },
                            {
                                question: "What Should I Expect During My Appointment?",
                                answer: "For mobile repairs, our technician will arrive at your location, confirm the needed work, and complete the repair on-site in about 45–90 minutes. If you visit us at Valvoline for a consultation, you’ll receive a preliminary assessment and can book a mobile service appointment right from there."
                            },
                            {
                                question: "Why Offer Both In-Person and Mobile Service?",
                                answer: "Every customer is different. Some prefer to speak with someone in person before booking service — others want the ease of mobile repair right away. By offering both, we’re able to meet you where you are — whether that’s inside our Valvoline partner location or at your driveway."
                            },
                            {
                                question: "What Areas Do You Serve Around ".concat(cityName, "?"),
                                answer: "We provide mobile service throughout ".concat(cityName, " and nearby communities including Brentwood, Franklin, Hendersonville, Antioch, and others. If you're within driving distance of a Valvoline partner location, you're likely in our service zone. Or visit us on-site for an in-person consultation and preliminary assessment!")
                            }
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CityNearYouSection, {
                        title: "The Best ".concat(cityName, " Mobile Brake Repair Near Me"),
                        description: "Stop searching for a local ".concat(cityName, " brake shop near you. We cover most of the ").concat(cityName, " metro area and bring the brake shop to you."),
                        listOfZips: listOfZips,
                        listOfMinorCities: listOfMinorCities
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BrakeRepairNearYouWithCities/* BrakeRepairNearYouWithCities */.r, {
                        title: "We’re the closest mobile brake repair service in ".concat(cityName, " near you. Skip waiting in line at the repair shop, we come to you!"),
                        cities: cities
                    })
                ]
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var _slug_ = (DynamicLocationPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4976,7948,2247,2978,4231,7858,4024,8202,8210,507,2932,6566,6263,7187,9435,2339,9774,2888,179], function() { return __webpack_exec__(91990); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);